"use client";

import { PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next";
import { usePathname } from "next/navigation";
import CakeFlavour from "@/components/CakeFlavour";
import { HorizontalDivider } from "@/components/HorizontalDivider";

export default function FlavoursMenu({ slice }) {
  if (slice.primary?.items?.length === 0) return null;

  return (
    <section className="mx-auto bg-[#e4e4e4] rounded-md py-10">
      <div className="w-1/2 mx-auto">
        <HorizontalDivider />
      </div>
      <div className="lg:items-start justify-start max-w-7xl mx-auto p-4 py-20 text-center ">
        <div className="flex w-full flex-col">
          <PrismicRichText field={slice.primary?.title} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-5 gap-y-32 px-5 lg:px-0 text-center">
          {slice.primary.items.map((item, index) => (
            <CakeFlavour flavour={item} key={item.id || index} />
          ))}
        </div>
        <div className="mt-40 text-center text-sm text-gray-600 border border-dashed  border-red-400  p-4 italic">
          <strong>IMPORTANT NOTE ON ALLERGENS:</strong>
          <br /> ‍Please be advised that our cakes are prepared in a kitchen
          where allergens such as <strong>Wheat</strong>, <strong>Eggs</strong>,{" "}
          <strong>Dairy</strong>, <strong>Tree Nuts</strong>,{" "}
          <strong>Peanuts</strong>,<strong>Sesame</strong>, and{" "}
          <strong>Soya</strong> are frequently used. Despite our efforts to
          prevent cross-contamination, there is always a risk of allergen
          exposure. <br />
          <br />
          If you have any concerns or allergies, kindly contact us for
          additional information or to make specific allergen requests prior to
          placing your order.
        </div>
        <div className="text-3xl font-serif italic mt-20 p-10 bg-white text-primary font-bold ">
          Make your flavour a taste to remember.
        </div>
      </div>
    </section>
  );
}
